import type { CardId } from '../../../model/types';

export const SET_CARD_ORDER_GLOBAL =
	'state.actions.card-order-global.SET_CARD_ORDER_GLOBAL' as const;

export interface SetCardOrderGlobalAction {
	type: typeof SET_CARD_ORDER_GLOBAL;
	payload: CardId[];
}

export const setCardOrderGlobal = (cardIds: CardId[]) => ({
	type: SET_CARD_ORDER_GLOBAL,
	payload: cardIds,
});
